class Controller {
  constructor($stateParams, $injector, Tag, TagTransforms, Sections) {
    "ngInject";

    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Tag = Tag;
    this.$stateParams = $stateParams;
    this.TagTransforms = TagTransforms;
    this.updateTagEvent = this.Events.eventsType.onUpdateTag;
    this.sections = Sections.settingsSections;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdateTag = (options) => {
      const params = {};
      params[options.key] = options.value;

      this.Tag.updateAction(
        this.$stateParams.id,
        options.methodName,
        params
      ).$promise.then(
        (response) => {
          this.tag = this.TagTransforms.justify(response);
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("Tag", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.Tag.get(this.$stateParams.id).$promise.then((response) => {
      this.tag = this.TagTransforms.justify(response);
    });

    this.Events.on(this.updateTagEvent, onUpdateTag);
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/tag/tag.controller.js